const translations = {
  "en": {
    "Edgen %{var0} 7-Day Subscription": "Ed %{var0} 7-Day Subscription",
    "Edgen %{var0} Month Subscription": "Ed %{var0} Month Subscription",
    "Edgen %{var0} Yearly Subscription": "Ed %{var0} Yearly Subscription"
  },
  "zh-tw": {
    "Edgen %{var0} 7-Day Subscription": "Ed %{var0} 7天訂閱",
    "Edgen %{var0} Month Subscription": "Ed %{var0} 月度訂閱",
    "Edgen %{var0} Yearly Subscription": "Ed %{var0} 年度訂閱"
  }
};

export default translations;
